import { render } from "./ProposalProductsRemove.vue?vue&type=template&id=c9d03c00&ts=true"
import script from "./ProposalProductsRemove.vue?vue&type=script&lang=ts"
export * from "./ProposalProductsRemove.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__